<template functional>
	<ActionFloatingButton class="go-to-profile" v-bind="props" v-tooltip="`Profil`">
		<svg class="go-to-profile__icon" width="22" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M12.5 11C14.7091 11 16.5 9.20914 16.5 7C16.5 4.79086 14.7091 3 12.5 3C10.2909 3 8.5 4.79086 8.5 7C8.5 9.20914 10.2909 11 12.5 11Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	</ActionFloatingButton>
</template>

<script>
	import ActionFloatingButton from "@/components/ActionFloatingButton"
	import VueTypes from "vue-types"

	export default {
		functional: true,
		props: {
			disabled: VueTypes.any,
			href: VueTypes.string.def("/user/profile"),
		},
		components: {
			ActionFloatingButton,
		},
	}
</script>

<style lang="scss" scoped>
	@use "~@scss/components/GoToProfile" as *;
</style>